import axios from "axios";

const vtmsUrl = "/v2/api/vtms";

class iVClientService {
  // Get Ivy Activation Parameters
  static getIvyActivationParameters() {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.get(`${vtmsUrl}/resources/activation-parameters`);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  // Create Ivy Activation
  static createIvyActivation(activationDetails) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.post(`${vtmsUrl}/clients`, {
          boston_contact_id: activationDetails.contact_id,
          ...activationDetails,
        });
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  // Get Ivy Activations
  static getIvyActivations(pagingOpts) {
    return new Promise(async (resolve, reject) => {
      try {
        pagingOpts = pagingOpts || {};

        let url = [
          `${vtmsUrl}/clients`,
          `?clientType=SW900V4`,
          `&page=${pagingOpts.currentPage || 1}`,
          `&limit=${pagingOpts.pageSize || 50}`,
          `&orderBy=${pagingOpts.field || "created_at"}`,
          `&order=${pagingOpts.isAsc ? "asc" : "desc" || "desc"}`,
          `&includeArchived=${pagingOpts.includeArchived ? 'Y' : 'N'}`,
        ].join("");

        let result = await axios.get(url);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  // Search Ivy Activations
  static searchIvyActivations(searchTerm, pagingOpts) {
    return new Promise(async (resolve, reject) => {
      try {
        pagingOpts = pagingOpts || {};

        let url = [
          `${vtmsUrl}/clients`,
          `?clientType=SW900V4`,
          `&searchTerm=${searchTerm}`,
          `&page=${pagingOpts.currentPage || 1}`,
          `&limit=${pagingOpts.pageSize || 50}`,
          `&orderBy=${pagingOpts.field || "created_at"}`,
          `&order=${pagingOpts.isAsc ? "asc" : "desc" || "desc"}`,
          `&includeArchived=${pagingOpts.includeArchived ? 'Y' : 'N'}`,
        ].join("");

        let result = await axios.get(url);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  // Get Ivy Activation By Id
  static getIvyActivationById(clientId) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.get(`${vtmsUrl}/clients/${clientId}`);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  // Set Ivy Activation Status
  static setIvyActivationsStatus(clientId, paymentStatus) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${vtmsUrl}/clients/${clientId}/metadata`;
        await axios.put(url, {
          payment_status: paymentStatus,
          payment_status_updated_at: Date.now().toString(),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  // Set Ivy Activation Status
  static setIvyActivationsProductCodes(clientId, productCodes) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.put(`${vtmsUrl}/clients/${clientId}/metadata`, {
          activated_product_codes: productCodes,
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  // Get Device Properties
  static getClientDeviceProperties(clientId) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.get(
          `${vtmsUrl}/clients/${clientId}/device/properties`,
        );
        resolve(result.data);
      } catch (error) {
        reject(error);
      }
    });
  }

  // Send Device Message
  static sendDeviceMessage(clientId, message) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.post(
          `${vtmsUrl}/clients/${clientId}/device/messages`,
          message,
        );
        resolve(result.data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static getDeviceUploads(clientId, dirPrefix) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.get(
          `${vtmsUrl}/clients/${clientId}/device/uploads?prefix=${dirPrefix}`,
        );
        resolve(result.data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static archiveClient(clientId) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.put(`${vtmsUrl}/clients/${clientId}/archive`);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static unarchiveClient(clientId) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.put(`${vtmsUrl}/clients/${clientId}/unarchive`);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static revokeClient(clientId) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.put(`${vtmsUrl}/clients/${clientId}/revoke`);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static unrevokeClient(clientId) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.put(`${vtmsUrl}/clients/${clientId}/unrevoke`);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static getChallengeOverrides(query) {
    return new Promise(async (resolve, reject) => {
      try {
        query = query || {};

        let url = [
          `${vtmsUrl}/challenge-overrides`,
          `?page=${query.currentPage || 1}`,
          `&limit=${query.pageSize || 50}`,
        ].join("");

        if (query.field) {
            url += `&orderBy=${query.field}&order=${query.isAsc ? "asc" : "desc"}`;
        }
        
        if (query.accessLevel) {
            url += `&data.access_request.access_level=${query.accessLevel}`;
        }

        if (query.fromDate) {
            url += `&fromDate=${query.fromDate}`;
        }
        
        if (query.toDate) {
            url += `&toDate=${query.toDate}`;
        }

        if (query.searchTerm) {
            url += `&searchTerm=${query.searchTerm}`;
        }

        let result = await axios.get(url);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static exportChallengeOverridesCsv(query) {
    return new Promise(async (resolve, reject) => {
      try {
        query = query || {};

        let url = `${vtmsUrl}/challenge-overrides/export-csv?`;

        let params = [];
        if (query.searchTerm) params.push(`searchTerm=${query.searchTerm}`);
        if (query.accessLevel) params.push(`data.access_request.access_level=${query.accessLevel}`);
        if (query.fromDate) params.push(`fromDate=${query.fromDate}`);
        if (query.toDate) params.push(`toDate=${query.toDate}`);
        
        url += params.join("&");

        let result = await axios.get(url, { responseType: 'blob' });
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }
}

export default iVClientService;
